import { ClientError, UserPasskey } from "../types";

export enum AuthenticationViews {
    join = "join",
    joinSuccess = "joinSuccess",
    setPassword = "setPassword",
    login = "login",
    verifyPasswordInitNonce = "verifyPasswordInitNonce",
    verifyPasswordResetNonce = "verifyPasswordResetNonce",
    forgotPassword = "forgotPassword",
    initializePassword = "initializePassword",
    resetPassword = "resetPassword",
    enableMfa = "enableMfa",
    verifyMfa = "verifyMfa",
    recoveryCodes = "recoveryCodes",
    addPasskey = "addPasskey",
    addTotp = "addTotp",
    mfa = "mfa",
}

export type AuthenticationAction =
    | { type: "SET_ACTIVE_VIEW"; payload: AuthenticationViews | undefined }
    | { type: "SET_CLIENT_ERRORS"; payload: ClientError[] }
    | { type: "SET_EMAIL"; payload: string }
    | { type: "SET_FIRST_NAME"; payload: string }
    | { type: "SET_IS_LOADING"; payload: boolean }
    | { type: "SET_LAST_NAME"; payload: string }
    | { type: "SET_LAST_SESSION_COOKIE"; payload: string }
    | { type: "SET_LOGIN_CHECK_TIMER"; payload: number }
    | { type: "SET_REDIRECT_URL"; payload: string }
    | { type: "SET_REMEMBER_ME"; payload: boolean }
    | { type: "SET_SERVER_ERROR"; payload: string }
    | { type: "SET_SIGN_IN_ID"; payload: string }
    | { type: "SET_USER_NAME"; payload: string }
    | { type: "SET_VERIFICATION_CODE"; payload: string }
    | { type: "SET_VERIFIED_NONCE_TOKEN"; payload: string }
    | { type: "SET_TOTP_KEY"; payload: string | null }
    | { type: "SET_TOTP_QR_CODE_URI"; payload: string | null }
    | { type: "SET_RECOVERY_CODES"; payload: string[] }
    | { type: "SET_IS_TOTP_ENABLED"; payload: boolean }
    | { type: "SET_PASSKEYS"; payload: UserPasskey[] };

export type State = {
    activeView?: AuthenticationViews;
    clientErrors: ClientError[];
    isLoading: boolean;
    email: string;
    firstName: string;
    lastName: string;
    lastSessionCookie: string;
    loginCheckTimer?: number;
    redirectUrl: string;
    rememberMe: boolean;
    serverError: string;
    signInId: string;
    userName: string;
    verificationCode: string;
    verifiedNonceToken: string;
    totpKey?: string | null;
    totpQrCodeUri?: string | null;
    recoveryCodes?: string[];
    isTotpEnabled?: boolean;
    passkeys: UserPasskey[];
};
